import React from 'react'
import { useTranslation } from 'react-i18next'

import "./publicManagement.scss"
import SectionComponent from '../../../../components/utils/SectionComponent'

function PublicManagement() {
  const { t } = useTranslation()

  return (
    <div className='container-public-management'>
      <div className='texts-public-management'>

        <SectionComponent title={t("public_sector.mgnt.title")} text={t("public_sector.mgnt.section_text_1")}>
          <p>{t("public_sector.mgnt.section_text_2")}</p>
        </SectionComponent>

      </div>
    </div>
  )
}

export default PublicManagement